import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const SUBMIT_DOCUMENTS_TO_ESMD = "SUBMIT_DOCUMENTS_TO_ESMD";

export const service = async (data) => {
  const options: object = {
    url: "/api/EsMd/SubmitDocumentsToEsmd",
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => Promise.resolve(mockData());

register(SUBMIT_DOCUMENTS_TO_ESMD, service, mock);
